import { Balancas, ValorNomeDispositivos } from '../../../components/modal-dispositivos-bluetooth/dispositivos-bluetooth.data'
import { setObserverMensagemStatusConexao } from '../../../services/bluetooth/dispositivos/observer-dispositivos'
import { ErrorBluetooth } from '../../../services/bluetooth/Error/ErrorBluetooth'
import {
  BluetoothConexaoDispositivoIsolado,
  DispositivoConexao,
  DispositivoLowenergy,
  DispositivoSelecionado,
  OpcoesBuscarPorDispositivos,
  OpcoesBuscarPorDispositivosLowEnergy,
  OpcoesConexaoBluetooth,
  OpcoesNotificacoesBluetoothLowEnergy,
  ResultadoConexaoBluetooth,
  StatusConexao
} from '../../../services/bluetooth/interfaces/bluetooth-interface'
import { GlobalService } from '../../../services/global.service'
import { UtilsService } from '../../../services/utils.service'
import { Injectable } from '@angular/core'
import { VastaRX } from '@vasta/rx'
import Utils from '../../../utils/utils'
import { BleClient, numbersToDataView } from '@capacitor-community/bluetooth-le'
import { BluetoothHelperService } from '../_helpers/helper-classic.service'
import { HelperLowEnergyService } from '../_helpers/helper-low-energy.service'

@Injectable({
  providedIn: 'root'
})
export class BalancaPrixMGRCampoService implements BluetoothConexaoDispositivoIsolado {
  private idAparelho = ValorNomeDispositivos.balancas.MGRCampo
  private dadosAparelho = Balancas.find((balanca) => balanca.value === this.idAparelho)
  private balancaLowEnergy: DispositivoSelecionado = {
    name: this.idAparelho,
    nome_modelo: this.dadosAparelho.nome,
    id: null
  }

  private isDesconectandoDispositivoManualmente: boolean

  /* MENSAGENS DE ERRO */
  private mensagemErroPerdaDeConexaoDaBalanca = 'Conexão com balança perdida, tente conecta-la novamente'
  private utils = Utils

  private opcoesDeNotificacoesLE: Omit<OpcoesNotificacoesBluetoothLowEnergy, 'deviceId'> = {
    service: '569a1101-b87f-490c-92cb-11ba5ea5167c',
    characteristic: '569a2000-b87f-490c-92cb-11ba5ea5167c'
  }

  public interval: any

  constructor(
    private bluetoothLEHelper: HelperLowEnergyService,
    private bluetoothHelper: BluetoothHelperService,
    private utilsCtrl: UtilsService,
    private globalCtrl: GlobalService
  ) { }

  async estabelecerConexao(): Promise<void> {
    try {
      const dispositivoConexao: DispositivoConexao = {
        tipoDispositivo: 'balanca',
        statusConexao: 'conectando'
      }

      VastaRX.setState('dispositivo_conexao', dispositivoConexao)


      const balancaEncontrada = await this.buscarDispositivo({ nomeDispositivo: this.balancaLowEnergy.name })

      const resultadoConexao = await this.estabelecerConexaoComBalanca({ deviceId: balancaEncontrada.deviceId })
      this.balancaLowEnergy.id = balancaEncontrada.deviceId

      if (resultadoConexao.isConnected) {
        const dispositivoConexao: DispositivoConexao = {
          dispositivoSelecionado: this.balancaLowEnergy,
          tipoDispositivo: 'balanca',
          statusConexao: 'conectado'
        }

        VastaRX.setState('dispositivo_conexao', dispositivoConexao)

        await this.receberDadosDaBalanca(balancaEncontrada)
      }
    } catch (error) {
      console.error(error)

      const dispositivoConexao: DispositivoConexao = {
        tipoDispositivo: 'balanca',
        statusConexao: 'erro-conexao'
      }

      VastaRX.setState('dispositivo_conexao', dispositivoConexao)

      if (error instanceof ErrorBluetooth) {
        this.utilsCtrl.exibirToast(error.message, this.utils.tempoDeExibicaoDeMensagemDeErro(error.message))
      }
    }
  }

  async buscarDispositivo(opcoes: OpcoesBuscarPorDispositivos): Promise<DispositivoLowenergy> {
    const resultadoBluetooth = await this.bluetoothLEHelper.isBluetoothLEHabilitado()

    if (!resultadoBluetooth?.isEnabled) {
      throw new ErrorBluetooth('O bluetooth está desabilitado')
    }

    /************ BUSCAR POR DISPOSITIVOS QUE ESTEJAM CONECTADOS ************************************* */
    const dispositivosConectados = await this.bluetoothLEHelper.getDispositivosConectados({
      services: [this.opcoesDeNotificacoesLE.service]
    })
    console.warn('dispositivosConectados: ', dispositivosConectados)

    if (dispositivosConectados?.length) {
      const dispositivoEncontrado = dispositivosConectados.find((device) => device?.name?.includes(opcoes.nomeDispositivo) || device?.name?.includes('CSB'))
      console.warn('dispositivo já estava conectado: ', dispositivoEncontrado)

      if (dispositivoEncontrado) {
        return dispositivoEncontrado
      }
    }

    // BUSCAR POR DISPOSITIVOS QUE NÃO ESTEJAM CONECTADOS
    const opcoesDeBusca: OpcoesBuscarPorDispositivosLowEnergy = {
      limiteDeBuscas: 10,
      services: [this.opcoesDeNotificacoesLE.service]
    }

    const isBuscarDispositivoPorPainel = false

    let dispositivoEncontrado: DispositivoLowenergy = null

    // PROCURAR DISPOSITIVOS DENTRO DE UM PAINEL
    if (isBuscarDispositivoPorPainel) {
      dispositivoEncontrado = await this.buscarDispositivosPorEmPainel()
    } else {
      // PROCURAR DISPOSITIVOS DE FORMA AUTOMÁTICA

      const dispositivos = await this.bluetoothLEHelper.pluginBuscarDispositivo(opcoesDeBusca)
      console.warn('dispositivos lowenergy ', dispositivos)

      const balancasEncontradas = dispositivos.devices.filter((device) => device?.name?.includes(opcoes.nomeDispositivo) || device?.name?.includes('CSB'))

      if (!balancasEncontradas || !balancasEncontradas.length) {
        throw new ErrorBluetooth('Nenhuma balança encontrada')
      }

      console.log('balancasEncontradas', balancasEncontradas)
      if (balancasEncontradas.length === 1) {
        dispositivoEncontrado = balancasEncontradas[0]
      } else {
        try {
          dispositivoEncontrado = await this.bluetoothLEHelper.actionSheetSeletorDispositivo({ devices: balancasEncontradas })
        } catch (e) {
          console.error('e', e)
          if (!dispositivoEncontrado) {
            throw new ErrorBluetooth('Falha ao listar dispositivos')
          }
        }
      }
      console.warn('dispositivo lowenergy Encontrado: ', dispositivoEncontrado)
    }

    if (!dispositivoEncontrado) {
      throw new ErrorBluetooth('Dispositivo não encontrado')
    }

    console.warn('dispositivoEncontrado: ', dispositivoEncontrado)

    return dispositivoEncontrado
  }

  async receberDadosDaBalanca(device: DispositivoLowenergy): Promise<void> {
    const resultadoBluetooth = await this.bluetoothLEHelper.isBluetoothLEHabilitado()

    if (!resultadoBluetooth?.isEnabled) {
      throw new ErrorBluetooth('O bluetooth está desabilitado')
    }

    setObserverMensagemStatusConexao({
      mensagemStatusConexao: 'Pronto para receber dados da balança',
      isEsconderMensagem: true
    })

    this.saidaDeDadosBalanca({ deviceId: device.deviceId })
  }

  saidaDeDadosBalanca(opcoes: OpcoesConexaoBluetooth): void {
    const opcoesNotificacoes: OpcoesNotificacoesBluetoothLowEnergy = {
      ...this.opcoesDeNotificacoesLE,
      deviceId: opcoes.deviceId
    }

    this.bluetoothLEHelper.startNotifications(opcoesNotificacoes).subscribe((result: DataView) => {
      const enc = new TextDecoder("utf-8");
      const arr = new Uint8Array(result.buffer);
      const dado = enc.decode(arr)
      const [peso, situacao] = dado.split('P')
      
      const valorFormatado = Number(peso.replace(',','.'))
      console.log('pesoFormatado: ', valorFormatado)
      this.bluetoothLEHelper.emitirPesoFormatado(String(valorFormatado))
    })

    const comandoPeso = this.bluetoothHelper.getComandoBalanca(';peso')

    this.interval = setInterval(() => {
      BleClient.write(opcoes.deviceId, '569a1101-b87f-490c-92cb-11ba5ea5167c', '569a2001-b87f-490c-92cb-11ba5ea5167c', numbersToDataView(comandoPeso))
    }, 500)
  }

  // Custom
  async buscarDispositivosPorEmPainel(): Promise<DispositivoLowenergy> {
    try {
      const device = await BleClient.requestDevice({ namePrefix: 'CSB' })

      const dispositivosLowenergy: DispositivoLowenergy = {
        ...device
      }

      return dispositivosLowenergy
    } catch (error) {
      console.error(error)
    }
  }

  async estabelecerConexaoComBalanca(opcoes: OpcoesConexaoBluetooth): Promise<ResultadoConexaoBluetooth> {
    return new Promise((resolve, reject) => {
      this.bluetoothLEHelper.pluginConectarBalanca({ deviceId: opcoes.deviceId }).subscribe(
        (success: ResultadoConexaoBluetooth) => {
          console.warn('sucesso ao conectar: ', success)

          if (success.isConnected) {
            const { deviceId, isConnected } = success
            const resultadoConexao: ResultadoConexaoBluetooth = {
              deviceId,
              isConnected
            }

            // Habilitar para verificar quando o bluetooth for desconectado
            this.habilitarNotificacoesBluetooth()

            this.emitirResultadoConexao({
              message: 'Balança conectada',
              isConnected: true
            })

            this.bluetoothLEHelper.emitirPesoFormatado('0')

            resolve(resultadoConexao)
          }
        },
        (fail: ResultadoConexaoBluetooth) => {
          console.error('Conexão perdida!! ', fail)

          clearInterval(this.interval)

          if (!this.isDesconectandoDispositivoManualmente) {
            this.emitirResultadoConexao({
              message: this.mensagemErroPerdaDeConexaoDaBalanca,
              isConnected: false
            })
          }

          const error = new ErrorBluetooth(this.mensagemErroPerdaDeConexaoDaBalanca)
          reject(error)
        }
      )
    })
  }

  private habilitarNotificacoesBluetooth(): void {
    this.bluetoothLEHelper.pluginHabilitarNotificacoesBluetooth().subscribe((resultadoBluetooth) => {
      if (!resultadoBluetooth.isEnabled) {
        this.emitirResultadoConexao({
          message: this.mensagemErroPerdaDeConexaoDaBalanca,
          isConnected: false
        })
      }
    })
  }

  private emitirResultadoConexao(opcoes: Omit<ResultadoConexaoBluetooth, 'deviceId'>): void {
    this.utilsCtrl.exibirToast(opcoes.message)
    this.globalCtrl.set('balanca_conectada', opcoes.isConnected ? this.balancaLowEnergy : null)

    const statusConexao: StatusConexao = opcoes?.statusConexao
      ? opcoes?.statusConexao
      : opcoes.isConnected
      ? 'conectado'
      : 'desconectado'

    const dispositivoConexao: DispositivoConexao = {
      dispositivoSelecionado: this.balancaLowEnergy,
      statusConexao,
      tipoDispositivo: 'balanca',
    }

    VastaRX.setState('dispositivo_conexao', dispositivoConexao)
    setObserverMensagemStatusConexao({ mensagemStatusConexao: opcoes?.message, isEsconderMensagem: !opcoes.isConnected  })
  }

  public async desconectarDispositivo(device: DispositivoLowenergy): Promise<void> {
    try {
      this.isDesconectandoDispositivoManualmente = true
      
      await BleClient.disconnect(device.deviceId)
      
      this.emitirResultadoConexao({
        isConnected: false,
        message: 'Balança Desconectada'
      })

    } catch(error) {
      console.error(error)
    } finally {
      this.isDesconectandoDispositivoManualmente = false
    }
  }
}
